import {
  onEnterExperimentPlan,
  onSelectTrialPlacementOptions,
  onEnterProductApplicationRate,
  onFinishFlow
} from './stepActions';

const stepActions = [
  undefined, // stepActions indexes maps to steps in TrialScript component step 0
  onEnterExperimentPlan,
  onSelectTrialPlacementOptions,
  onEnterProductApplicationRate,
  onFinishFlow
];

export default {
  stepActions
};
